import type { RootState } from 'react-redux';
import { createSelector } from 'reselect';

import type { RouterState } from './slice';

export const getRouter = (state: RootState) => state.router;

export const getLocation = createSelector(
  getRouter,
  (state: RouterState) => state.location?.location || {},
);

export const getHost = createSelector(getRouter, (state: RouterState) => state.host);

export const getLocationAction = createSelector(
  getRouter,
  (state: RouterState) => state.location.action,
);

export const getProtocol = createSelector(
  getRouter,
  (state: RouterState) => state.location.protocol,
);

export const getLocationPending = createSelector(
  getRouter,
  (state: RouterState) => state.location.isPending,
);
